import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-cbefe314"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "installment-list"
}
const _hoisted_2 = { class: "animation-container" }
const _hoisted_3 = { class: "loading-animation" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DotLottieVue = _resolveComponent("DotLottieVue")!
  const _component_InstallmentsList = _resolveComponent("InstallmentsList")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_NoPayments = _resolveComponent("NoPayments")!

  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_DotLottieVue, {
              style: {"height":"150px","width":"150px","padding":"0"},
              autoplay: "",
              loop: "",
              src: "/assets/loader.lottie",
              "auto-resize-canvas": true
            }),
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t("Cargando...")), 1)
          ])
        ])
      ]))
    : (_ctx.installments && _ctx.installments.installments.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_InstallmentsList, {
            title: _ctx.$t('InstallmentsList-Title'),
            "installment-details": _ctx.installments,
            onSelectInstallmentItem: _ctx.handleSelectInstallment
          }, null, 8, ["title", "installment-details", "onSelectInstallmentItem"])
        ]))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_ErrorMessage)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_NoPayments)
          ]))
}